import Scrollbar from '../../Scrollbar';
import Navigation from '../Navigation/Navigation';

const DrawerContent = () => {
  return (
    <Scrollbar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Navigation />
    </Scrollbar>
  );
};

export default DrawerContent;
